import React, { Component } from 'react';

import http from 'Demora/http';

import Loading from 'Demora/Loading';

import moment from 'moment';

import Table from '../helpers/Table';

import { withRouter } from 'react-router-dom';

import './statsHome.scss';

let current = 0;

class StatsHome extends Component {
	constructor(props) {
		super();

		const usp = new URLSearchParams(props.location.search);

		this.state = {
			opened: { '-1': true, 0: true },
			path: usp.get('path') || '',
			type: usp.get('type') || 0,
			uid: usp.get('uid') || 0,
			visit: usp.get('visit'),
		};
	}

	componentDidMount() {
		this.unmounted = true;
	}

	componentDidMount() {
		this.getData();
	}

	getData = () => {
		const { path, type, uid, visit } = this.state;

		const url =
			'/data/z5-stats/stats?type=' +
			type +
			(path
				? '&path=' + encodeURIComponent(path)
				: visit
					? '&visit=' + visit
					: uid
						? '&uid=' + uid
						: '');

		http.get(url).then((data) => {
			if (!data.rufP || this.unmounted) {
				return;
			}

			this.setState({
				stats: data.stats,
			});
		});
	};

	getDomain = () => {
		if (document.location.port == 8080) {
			return 'http://cashjuice.test:8000';
		}

		return '';
	};

	updatePath = (event) => {
		this.setState({
			path: event.currentTarget.value,
			visit: '',
		});
	};

	updateUID = (event) => {
		this.setState({
			uid: event.currentTarget.value,
			visit: '',
		});
	};

	update = () => {
		const { path, uid, visit } = this.state;

		const url =
			'/z5-stats' + (uid ? '?uid=' + uid : path ? '?path=' + path : '');

		this.props.history.push(url);

		this.getData();
	};

	showVisit = (visit) => {
		this.setState(
			{
				path: '',
				visit,
			},
			() => {
				this.update();
			}
		);
	};

	showURLTree = (stats, previous) => {
		const { opened } = this.state;

		return Object.keys(stats).map((k) => {
			const arr = stats[k];

			const current1 = current;

			current++;

			return (
				<ul
					className={'nested' + (!!opened[previous] ? ' active' : '')}
					key={current1}
				>
					<li>
						<span
							className={
								previous > -1
									? 'caret' + (!!opened[current1] ? ' caret-down' : '')
									: ''
							}
							onClick={() => {
								if (current1 === 0) {
									return;
								}

								opened[current1] = !opened[current1];

								this.setState({
									opened: Object.assign({}, opened),
								});
							}}
						>
							{arr.c} - {k}
						</span>
						{this.showURLTree(arr.d, current1)}
					</li>
				</ul>
			);
		});
	};

	render() {
		const { path, stats, type, uid, visit } = this.state;

		if (!stats) {
			return <Loading />;
		}

		if (type == 1) {
			current = 0;
			return (
				<ul id='myUL'>
					<li>{this.showURLTree(stats, '-1')}</li>
				</ul>
			);
		}

		const columns = [
			{
				align: 'left',
				accessor: 's',
				Cell: ({ value, row }) =>
					moment(value * 1000).format('Do MMM YY HH:mm:ss'),
				headerAlign: 'center',
				Header: 'Action',
				width: 160,
			},
			{
				align: 'left',
				accessor: 'e',
				Cell: ({ value, row }) =>
					moment(value * 1000).format('Do MMM YY HH:mm:ss'),
				headerAlign: 'center',
				Header: 'Action',
				width: 160,
			},
			{
				align: 'right',
				accessor: 'u',
				headerAlign: 'center',
				Header: 'User',
				width: 80,
			},
			{
				align: 'left',
				accessor: 'url',
				headerAlign: 'center',
				Header: 'URL',
				width: 200,
			},
			{
				align: 'left',
				accessor: 'c',
				Cell: ({ value, row }) => {
					const c = value.toString(36).toLowerCase();
					return (
						<div>
							{c}{' '}
							<img src={this.getDomain() + '/assets/countries/' + c + '.gif'} />
						</div>
					);
				},
				headerAlign: 'center',
				Header: 'Country',
				width: 50,
			},
			{
				align: 'left',
				accessor: 'l',
				Cell: ({ value, row }) => value.toString(36),
				headerAlign: 'center',
				Header: 'Language',
				width: 50,
			},
		];

		return (
			<div>
				<div>
					UID <input type='number' value={uid} onChange={this.updateUID} />
				</div>
				<div>
					Path <input type='text' value={path} onChange={this.updatePath} />
				</div>
				<button className='btn btn-primary' onClick={this.update}>
					Update
				</button>
				{stats.map((v, k) => {
					return (
						<div key={k}>
							<button
								className='btn btn-primary'
								onClick={(e) => this.showVisit(v[0].visit)}
							>
								See Visit
							</button>
							<Table columns={columns} data={v} />
						</div>
					);
				})}
			</div>
		);
	}
}

export default withRouter(StatsHome);
